import {datasets} from './datasets/index.js';
import {images} from './images/index.js';
import {sounds} from './sounds/index.js';

const assets = [

    ...datasets,
    ...images,
    ...sounds
];

export {assets};
